// Libs
import { Box, Dialog, DialogContent, DialogTitle } from '@mui/material';
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
// import { BaseTabList } from '~/components/common';
import { ScheduleDetailSummary } from '~/components/module/schedules';
// Others
import { ISchedule } from '~/utils/interface/schedule';
// Styles, images, icons
import styles from './ScheduleDetailModal.module.scss';

type Props = {
  data?: ISchedule;
  onClose: () => void;
  onDeleteSchedule?: (scheduleId: string) => void;
  onEditSchedule?: (scheduleId: string) => void;
  onShowDetail?: (scheduleId: string) => void;
};

const cx = classNames.bind(styles);

const ScheduleDetailModal = (props: Props) => {
  //#region Destructuring Props
  const { data, onClose, onDeleteSchedule, onEditSchedule, onShowDetail } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/schedule', 'common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const handleCancelScheduleDetail = () => {
    onClose();
  };
  //#endregion Handle Function

  return (
    <Dialog
      id='scheduleDetailModalPage'
      open={true}
      fullWidth
      maxWidth={'md'}
      onClose={handleCancelScheduleDetail}
    >
      <DialogTitle>{t('schedule_detail_title')}</DialogTitle>

      <DialogContent dividers={true}>
        <Box component={'div'} className={cx('tabContent')}>
          <ScheduleDetailSummary
            data={data}
            onShowConfirmDelete={onDeleteSchedule}
            onShowEditSchedule={onEditSchedule}
            onShowDetail={onShowDetail}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ScheduleDetailModal;
